"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupManagementModal = void 0;
const edit_1 = require("client/components/icons/edit");
const button_1 = require("client/components/material/button");
const Button_1 = require("material-ui/Button/Button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_rnd_1 = require("react-rnd");
const style = {
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // border: "solid 1px #ddd",
    boxShadow: "0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2)",
    background: "#f0f0f0",
    zIndex: 777
};
let GroupManagementModal = class GroupManagementModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalIsOpen = false;
        this.groupModal = {
            width: 300,
            height: 200,
            x: 100,
            y: -100
        };
        this.handleToggle = () => {
            this.modalIsOpen = !this.modalIsOpen;
        };
        /**
         * Save modal position on drag stop
         */
        this.handleOnDragStop = (event, d) => {
            event.stopPropagation();
            this.groupModal = Object.assign(Object.assign({}, this.groupModal), { x: d.x, y: d.y });
        };
        this.handleOnResize = (e, direction, ref, delta, position) => {
            /**
             * Merge size changes to this.groupModal
             */
            this.groupModal = Object.assign(Object.assign(Object.assign({}, this.groupModal), { width: ref.style.width, height: ref.style.height }), position);
        };
        this.handleOnClose = () => {
            this.modalIsOpen = false;
        };
        this.renderEditButton = () => (React.createElement(Button_1.default, { className: "edit-group__remove-button", onClick: event => {
                event.stopPropagation();
                this.handleToggle();
            }, color: "default" },
            React.createElement(edit_1.EditIcon, null)));
        this.renderGroupManagementModal = () => (React.createElement(react_rnd_1.Rnd, { style: style, size: { width: this.groupModal.width, height: this.groupModal.height }, position: { x: this.groupModal.x, y: this.groupModal.y }, onDragStop: this.handleOnDragStop, onResize: this.handleOnResize },
            React.createElement("div", { className: "modal-content-container" },
                React.createElement("button", { onClick: this.handleOnClose }, "close"),
                this.props.children)));
    }
    render() {
        return (React.createElement("div", { className: "group-management-modal" },
            this.props.useEditButton ? (this.renderEditButton()) : (React.createElement(button_1.MaterialButton, { secondary: true, className: "group-management-modal__button", onClick: this.handleToggle },
                " ",
                this.props.buttonLabel || "default text")),
            this.modalIsOpen && this.renderGroupManagementModal()));
    }
};
__decorate([
    mobx_1.observable
], GroupManagementModal.prototype, "modalIsOpen", void 0);
__decorate([
    mobx_1.observable
], GroupManagementModal.prototype, "groupModal", void 0);
GroupManagementModal = __decorate([
    mobx_react_1.observer
], GroupManagementModal);
exports.GroupManagementModal = GroupManagementModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/group-management-modal/group-management-modal.tsx
// module id = 3689
// module chunks = 0